import { Injectable } from '@angular/core';
import { LoggedUserInfo, Menu } from '../models/LoggedUserInfo';
import { BaseSearchCriteria } from '../models/searchCriteria/BaseSearchCriteria';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  getToken(): string | null {
    return sessionStorage.getItem('loggedUser-jwt');
  }
  setToken(jwt: string | undefined) {
    if (jwt)
      sessionStorage.setItem('loggedUser-jwt', jwt);
  }
  saveLoggedUser(loggedUser: LoggedUserInfo) {
    sessionStorage.setItem('loggedUser', JSON.stringify(loggedUser));
  }

  getLoggedUser(): LoggedUserInfo {
    return JSON.parse(sessionStorage.getItem('loggedUser') as string);
  }


  isAuthenticated(): boolean {
    let user = sessionStorage.getItem('loggedUser');
    return user != null;
  }

  saveMenu(menu: Menu[]) {
    sessionStorage.setItem('menu', JSON.stringify(menu));
  }

  setValue(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getValue(key: string): any {
    let value = sessionStorage.getItem(key);
    return value != null ? JSON.parse(value) : null;
  }

  saveNavigationInfo(searchCriteria: BaseSearchCriteria,typeofInfo:string) {
    sessionStorage.setItem('navigationInfo_' + typeofInfo, JSON.stringify(searchCriteria));
  }

  retrieveNavigationInfo(typeofInfo: string): any | null {
    let key = 'navigationInfo_' + typeofInfo;
    if (sessionStorage.getItem(key) != null) {
      return JSON.parse(sessionStorage.getItem(key) as string);
    }
    return null;
  }

  logout() {
    sessionStorage.clear();
  }
}
